module.exports = __webpack_public_path__ + "static/media/logo.ce587868.png";